import React from 'react';
import { HashLink } from 'react-router-hash-link';

const NavLinks = () => {
    return (
        <>
            <HashLink className="text-white font-bold bg-red-900 hover:bg-red-800 inline-flex items-center justify-center w-full h-10 px-6 py-1 my-4 text-lg shadow-xl rounded-2xl sm:w-auto sm:mb-0" smooth to="/#home">
                Home
            </HashLink>
            <HashLink className="text-white font-bold bg-red-900 hover:bg-red-800 inline-flex items-center justify-center w-full h-10 px-6 py-3 my-4 text-lg shadow-xl rounded-2xl sm:w-auto sm:mb-0" smooth to="/#about">
                About
            </HashLink>
            <HashLink className="text-white font-bold bg-red-900 hover:bg-red-800 inline-flex items-center justify-center w-full h-10  px-6 py-3 my-4 text-lg shadow-xl rounded-2xl sm:w-auto sm:mb-0" smooth to="/#services">
                Services
            </HashLink>
            <HashLink className="text-white font-bold bg-red-900 hover:bg-red-800 inline-flex items-center justify-center w-full h-10  px-6 py-3 my-4 text-lg shadow-xl rounded-2xl sm:w-auto sm:mb-0" to="/#products">
                Pricing
            </HashLink>
            <HashLink className="text-white font-bold bg-red-900 hover:bg-red-800 inline-flex items-center justify-center w-full h-10  px-6 py-3 my-4 text-lg shadow-xl rounded-2xl sm:w-auto sm:mb-0" to="/#contact">
                Contact Us
            </HashLink>
        </>
    )
}

export default NavLinks;
